<template>
  <img
    :src="src"
    @click="$emit('click', $event)"
    :width="width"
    :height="height"
    :style="{ marginBottom: `${height * 0.05}px` }"
  />
</template>

<script>
export default {
  props: {
    imageData: {
      type: ImageData,
      default: null,
    },
    scale: {
      type: Number,
      default: 1.0,
    },
  },
  data() {
    return {
      canvas: document.createElement("canvas"),
      src: "",
    };
  },
  computed: {
    width() {
      if (!this.imageData) return 0;
      return this.scale * this.imageData.width;
    },
    height() {
      if (!this.imageData) return 0;
      return this.scale * this.imageData.height;
    },
  },
  watch: {
    imageData: {
      immediate: true,
      handler(newValue) {
        if (!newValue) return;
        this.canvas.width = newValue.width;
        this.canvas.height = newValue.height;
        this.canvas.getContext("2d").putImageData(newValue, 0, 0);
        this.src = this.canvas.toDataURL("image/png");
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>
